import moment from "moment";
import React, { useEffect, useState } from "react";
import { BsFillCheckCircleFill, BsFillXCircleFill } from "react-icons/bs";
import { FaExclamationTriangle } from "react-icons/fa";
import {
  Alert,
  Badge,
  Button,
  Card,
  Col,
  Collapse,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Table,
} from "reactstrap";
import {
  baseUrl,
  contvertHTMLToPlain,
  profilePicValidityCheck,
} from "../../../utils/constants";
import parse from "html-react-parser";
import Select from "react-select";
import { BiCalendarAlt } from "react-icons/bi";
import { addRemindMeToTrivvyResult } from "../../../utils/url";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import { isMobile } from "../../../utils/deviceInfo";
import {
  ActionLayoutData,
  ActionLayoutHeading,
  LayoutData,
  LayoutHeading,
  LayoutRow,
} from "../../weekly-wins/TableLayoutComponents";
import { connect } from "react-redux";
import { GiOpenTreasureChest } from "react-icons/gi";
import TrivvyLinkedRewardsDetailsModal from "./TrivvyLinkedRewardsDetailsModal";
import ReminderComponent from "./ReminderComponent";
import {
  getTrivvyTitleText,
  isTrivvyGeneratedFromCustomTemplates,
  SENTIMENTS_COLOR_MAP,
  SENTIMENTS_TYPO_MAP,
} from "../data";
import ViewSummaryCommon from "../../../components/Trivvy/ViewSummarycomon";
import { normalizeMessageText } from "../../../utils/normalizeText";
import "../trivvy-response-modal-bwai.css";

function MyTriviaDetails({ open, onClose, data, user, hideReminder,isMessaging, isRestyled, ...props }) {
  const getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "N";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "N";
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  const [questionIdTextMap, setQuestionIdTextMap] = useState(null);

  const [hideCorrectAnswerColumn, setHideCorrectAnswerColumn] = useState(false);

  const [triviaObject, setTriviaObject] = useState(null);
  console.log(triviaObject, "triviaObject");

  const [sourceTextModalOpen, setSourceTextModalOpen] = useState(false);
  const [rewardDescModalOpen, setRewardDescModalOpen] = useState(false);

  useEffect(() => {
    const q_id_map = {};
    if (data.quizResponses && data.quizResponses.length) {
      for (const res of data.quizResponses) {
        // A checkbox answer can have several chosen options. When more than one
        // is selected, show them all (joined as plain text, like the results
        // table) instead of just the first; keep the first answer's other
        // fields (e.g. option_id) for the correct/incorrect comparison below.
        const allSelected = Array.isArray(res.selected_answers)
          ? res.selected_answers.filter(Boolean)
          : [];
        q_id_map[res.question_id] = {
          selectedAnswer:
            allSelected.length > 1
              ? {
                  ...allSelected[0],
                  text: allSelected
                    .map((a) => contvertHTMLToPlain(a && a.text ? a.text : ""))
                    .filter(Boolean)
                    .join(", "),
                }
              : res.selected_answers[0],
          source: res.source,
          textSentimentsData: res.textSentimentsData,
        };
      }
    }

    


    setQuestionIdTextMap(q_id_map);

    axios.get(url.getTrivvyById(isMessaging ?  data.triviaId._id : data.triviaId)).then(({ data }) => {
      setTriviaObject(data.data);
    });
  }, []);
    const handleTakeTrivvy = (trivia) => {
    props.history.push(
        `/home/trivia/${trivia.organizationId}/quiz/${trivia._id}/start`
      );
    };

  useEffect(() => {
    if (data && triviaObject) {
      if (isTrivvyGeneratedFromCustomTemplates(triviaObject)) {
        setHideCorrectAnswerColumn(true);
        return;
      }

      if (data.allowAttempts > 0) {
        if (data.isFinalAttempt) {
          setHideCorrectAnswerColumn(false);
        } else if (data.percentCorrect == 100) {
          setHideCorrectAnswerColumn(false);
        } else if (triviaObject.allowAttempts == 2) {
          if (
            data.percentCorrect != null &&
            triviaObject &&
            triviaObject.minimumPassingPercent &&
            triviaObject.minimumPassingPercent != null &&
            triviaObject.minimumPassingPercent > 0
          ) {
            if (data.percentCorrect >= triviaObject.minimumPassingPercent) {
              setHideCorrectAnswerColumn(false);
            } else {
              setHideCorrectAnswerColumn(true);
            }
          } else {
            setHideCorrectAnswerColumn(true);
          }
        } else {
          setHideCorrectAnswerColumn(true);
        }
      }

      const isNoCorrectAnswersTrivvy =
        triviaObject.questions.filter(
          (x) =>
            x.correct_options &&
            x.correct_options[0] &&
            x.correct_options[0].text
        ).length == 0;

      if (isNoCorrectAnswersTrivvy) {
        setHideCorrectAnswerColumn(true);
      }
    }
  }, [triviaObject]);

  const quizResponses =
    questionIdTextMap && triviaObject && triviaObject.questions
      ? triviaObject.questions.map((x) => ({
          question: {
            question_text: x.question_text,
            correct_options: x.correct_options || null,
            question_type: x.question_type || "MCQ",
          },
          selectedAnswer: questionIdTextMap[x.question_id]
            ? questionIdTextMap[x.question_id].selectedAnswer
            : null,
          source:
            questionIdTextMap[x.question_id] &&
            questionIdTextMap[x.question_id].source,
          id: x.question_id,
          textSentimentsData:
            questionIdTextMap[x.question_id] &&
            questionIdTextMap[x.question_id].textSentimentsData,
        }))
      : [];

  const remindMeDdData = quizResponses
    .filter(
      (x) =>
        x.question.question_type == "MCQ" &&
        x.question.correct_options &&
        x.question.correct_options[0]
    )
    .map((doc, index) => {
      return {
        label: contvertHTMLToPlain(doc.question && doc.question.question_text),
        q_id: doc.id,
        value: index,
        correctOption: contvertHTMLToPlain(
          doc.question.correct_options && doc.question.correct_options[0]
            ? doc.question.correct_options[0].text
            : "NA" || "NA"
        ),
        answer: doc.selectedAnswer
          ? contvertHTMLToPlain(doc.selectedAnswer.text || "No Answer")
          : "No Answer",
      };
    });

  console.log({ quizResponses });

  const planType =
    user.profile &&
    user.profile.organizationId &&
    user.profile.organizationId.trivvyPlanType;

  const sourceLinkUrl = triviaObject ? triviaObject.uploadUrl : data.sourceLink;

  const sourceText = triviaObject && triviaObject.uploadText;

  const showSourceCol =
    data &&
    data.quizResponses &&
    data.quizResponses.filter((x) => x.source && x.source.length).length > 0
      ? true
      : false;

  const isSurveyCategory = data && data.triviaCategoryType === "SURVEY";

  // Phone table: size the rows to the columns that render, or Source wraps.
  let colUnits = 3;
  if (!hideCorrectAnswerColumn) colUnits += 2;
  if (!hideCorrectAnswerColumn && showSourceCol) colUnits += 2;
  const mobileTableWidth = colUnits * 122;

  const isNonMcQTrivvy =
    triviaObject &&
    triviaObject.questions &&
    Array.isArray(triviaObject.questions)
      ? triviaObject.questions.filter(
          (x) =>
            x.question_type == "MCQ" &&
            x.correct_options &&
            x.correct_options[0]
        ).length == 0
      : false;

  return (
    <Modal isOpen={open} className={isRestyled ? "bwai-response-modal" : undefined}>
      <ModalHeader className="trivia_modal_header_bg" toggle={onClose}>
        {data.userResultObj ? (
          <div>
            {data.isAnonymous ? (
              "Anonymous "
            ) : (
              <span>
                {data.userResultObj.firstName} {data.userResultObj.lastName}'s{" "}
              </span>
            )}
            Submission
          </div>
        ) : (
          <div>{getTrivvyTitleText(data.triviaName)} {isMessaging? "Information" : "Submission"} </div>
        )}
      </ModalHeader>
      <ModalBody className={"p-4 mtTriviaResultDetailsContainer"}>
        {triviaObject &&
          data &&
          (isMessaging ? (
            <Card className={"p-3 my-res-data-card"}>
              <Row>
                <Col md={6}>
                  <Row className={"my-2 h-fix"}>
                    <Col sm={3} className="text-left">
                      <b>Message name</b>{" "}
                    </Col>
                    <Col sm={9} className={isMobile ? "" : "text-right"}>
                      {getTrivvyTitleText(data.triviaId)}
                    </Col>
                  </Row>
                  {triviaObject.createdBy ? (
                    <Row className={"my-2 h-fix"}>
                      <Col sm={4} className="text-left">
                        <b>Created By</b>{" "}
                      </Col>
                      <Col sm={8} className={isMobile ? "" : "text-right"}>
                        {profilePicValidityCheck(
                          triviaObject.createdBy.profilePic
                        ) ? (
                          <img
                            src={triviaObject.createdBy.profilePic}
                            height="20px"
                            width="20px"
                            style={{ borderRadius: "50%" }}
                          />
                        ) : (
                          <span
                            className="spotlightUserInitials"
                            data-letters={getInitials(triviaObject.createdBy)}
                          ></span>
                        )}{" "}
                        {triviaObject.createdBy.firstName}{" "}
                        {triviaObject.createdBy.lastName}
                      </Col>
                    </Row>
                  ) : (
                    ""
                  )}
                </Col>

                <Col md={6}>
                  {triviaObject && !triviaObject.isBuiltInWithAiType ? (
                    <Row className={"my-2 h-fix"}>
                      <Col sm={6} className="text-left">
                        <b>Message Content</b>{" "}
                      </Col>
                      <Col sm={6} className={isMobile ? "" : "text-right"}>
                        {normalizeMessageText(triviaObject.messagingSubject)}
                      </Col>
                    </Row>
                  ) : (
                    ""
                  )}
                  <Row className={"my-2 h-fix"}>
                    <Col sm={5} className="text-left">
                      <b>Created Date</b>{" "}
                    </Col>
                    <Col sm={7} className={isMobile ? "" : "text-right"}>
                      {moment(data.quizSubmittedAt).format("DD MMM - YYYY")}
                    </Col>
                  </Row>{" "}
                  {/* <Row className={"my-2 h-fix"}>
                    <Col sm={5} className="text-left">
                      <b>Respond Here</b>{" "}
                    </Col>
                    <Col sm={7} className={isMobile ? "" : "text-right"}>
                      <Button
                        onClick={(e) => {
                        handleTakeTrivvy(data.triviaId._id);
                        }}
                      >
                        Submit Response
                      </Button>
                    </Col>
                  </Row> */}
                </Col>
              </Row>
            </Card>
          ) : (
            <Card className={"p-3 my-res-data-card"}>
              <Row>
                <Col md={6}>
                  <Row className={"my-2 h-fix"}>
                    <Col sm={3} className="text-left">
                      <b>Trivvy:</b>{" "}
                    </Col>
                    <Col sm={9} className={isMobile ? "" : "text-right"}>
                      {getTrivvyTitleText(data.triviaName)}
                    </Col>
                  </Row>
                  {triviaObject.createdBy ? (
                    <Row className={"my-2 h-fix"}>
                      <Col sm={4} className="text-left">
                        <b>Created By:</b>{" "}
                      </Col>
                      <Col sm={8} className={isMobile ? "" : "text-right"}>
                        {profilePicValidityCheck(
                          triviaObject.createdBy.profilePic
                        ) ? (
                          <img
                            src={triviaObject.createdBy.profilePic}
                            height="20px"
                            width="20px"
                            className="rounded-circle"
                          />
                        ) : (
                          <span
                            className="spotlightUserInitials"
                            data-letters={getInitials(triviaObject.createdBy)}
                          ></span>
                        )}{" "}
                        {triviaObject.createdBy.firstName}{" "}
                        {triviaObject.createdBy.lastName}
                      </Col>
                    </Row>
                  ) : (
                    ""
                  )}
                  <Row className={"my-2 h-fix"}>
                    <Col sm={5} className="text-left">
                      <b>Response Date:</b>{" "}
                    </Col>
                    <Col sm={7} className={isMobile ? "" : "text-right"}>
                      {moment(data.quizSubmittedAt).format("DD MMM - YYYY")}
                    </Col>
                  </Row>{" "}
                  {triviaObject &&
                  triviaObject.minimumPassingPercent &&
                  triviaObject.minimumPassingPercent > 0 ? (
                    <Row className={"my-2 h-fix"}>
                      <Col sm={6} className="text-left">
                        <b>Minimum passing percent</b>{" "}
                      </Col>
                      <Col sm={6} className={isMobile ? "" : "text-right"}>
                        {Math.round(triviaObject.minimumPassingPercent) || 0} %
                      </Col>
                    </Row>
                  ) : (
                    ""
                  )}
                </Col>

                <Col md={6}>
                  {triviaObject && !triviaObject.isBuiltInWithAiType ? (
                    <Row className={"my-2 h-fix"}>
                      <Col sm={6} className="text-left">
                        <b>Source </b>{" "}
                      </Col>
                      <Col sm={6} className={isMobile ? "" : "text-right"}>
                        {sourceLinkUrl ? (
                          <a
                            href={sourceLinkUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {triviaObject.uploadType == 0
                              ? "Webpage"
                              : "Document"}
                          </a>
                        ) : sourceText ? (
                          <div
                            onClick={() => setSourceTextModalOpen(true)}
                            className="text-info cursor-pointer"
                          >
                            Custom Text
                          </div>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>
                  ) : (
                    ""
                  )}

                  <Row className={"my-2 h-fix"}>
                    <Col sm={6} className="text-left">
                      <b>Score:</b>{" "}
                    </Col>
                    <Col sm={6} className={isMobile ? "" : "text-right"}>
                      {isNonMcQTrivvy ? (
                        "NA"
                      ) : (
                        <span>{Math.round(data.percentCorrect) || 0} %</span>
                      )}
                    </Col>
                  </Row>
                  <Row className={"my-2 h-fix"}>
                    <Col sm={6} className="text-left">
                      <b>Total Duration:</b>{" "}
                    </Col>
                    <Col sm={6} className={isMobile ? "" : "text-right"}>
                      {data.totalTime} seconds
                    </Col>
                  </Row>
                  {/* <Row className={"my-2 h-fix"}>
                    <Col sm={6} className="text-left">
                      <b>Completion %</b>{" "}
                    </Col>
                    <Col sm={6} className={isMobile ? "" : "text-right"}>
                      {Math.round(data.completion) || 0} %
                    </Col>
                  </Row>
                  <Row className={"my-2 h-fix"}>
                    <Col sm={6} className="text-left">
                      <b>Rating</b>{" "}
                    </Col>
                    <Col sm={6} className={isMobile ? "" : "text-right"}>
                      {data.rating > 0 ? data.rating : "No rating"}
                    </Col>
                  </Row>
                  <Row className={"my-2 h-fix"}>
                    <Col sm={6} className="text-left">
                      <b>Rating Comment</b>{" "}
                    </Col>
                    <Col sm={6} className={isMobile ? "" : "text-right"}>
                      {data.ratingComment ? data.ratingComment : "No Comment"}
                    </Col>
                  </Row> */}
                </Col>
              </Row>
            </Card>
          ))}

        {triviaObject &&
        triviaObject.linkedRewards &&
        triviaObject.linkedRewards.length ? (
          <div
            className="mb-5 font-weight-bold pb-3 pl-3 cursor-pointer"
            style={{ color: "#9227C6" }}
            onClick={() => setRewardDescModalOpen(true)}
          >
            <GiOpenTreasureChest size={24} className="mr-1" /> This Trivvy is
            part of a reward. Click to see description
          </div>
        ) : (
          ""
        )}

        {data.librarySummaryText && (
          <div className="my-3">
            <ViewSummaryCommon summaryText={data.librarySummaryText} />
          </div>
        )}

        {rewardDescModalOpen && (
          <TrivvyLinkedRewardsDetailsModal
            open={rewardDescModalOpen}
            onClose={() => setRewardDescModalOpen(false)}
            trivvyId={triviaObject._id}
          />
        )}

        <Modal
          isOpen={sourceTextModalOpen}
          className={isRestyled ? "bwai-response-modal" : undefined}
        >
          <ModalHeader
            className="trivia_modal_header_bg"
            toggle={() => setSourceTextModalOpen(false)}
          >
            Source Text
          </ModalHeader>
          <ModalBody className="p-3">{sourceText}</ModalBody>
        </Modal>

        {quizResponses && quizResponses.length > 0 ? (
          <div>
            {isMobile ? (
              <div className="">
                <LayoutRow
                  plainTable={true}
                  className="mobileNoheightActionTable"
                >
                  <Col xs={5}>
                    <div style={{}}>
                      <ActionLayoutHeading
                        plainTable={true}
                        className="p-2"
                        colWidth={3}
                        fullWidth
                      >
                        Question
                      </ActionLayoutHeading>

                      {quizResponses.map((x, i) => {
                        return (
                          <Row
                            style={{
                              height: "150px",
                              overflowY: "auto",
                              overflowX: "hidden",
                            }}
                            key={`${i}`}
                            className="border p-2"
                          >
                            {parse(x.question && x.question.question_text)}
                          </Row>
                        );
                      })}
                    </div>
                  </Col>
                  <Col xs={7} className="scrollable-action-table-row pl-2">
                    <Row
                      className=" mx-0 px-0"
                      style={{ width: `${mobileTableWidth}px` }}
                    >
                      <ActionLayoutHeading
                        plainTable
                        className={"justify-content-center "}
                        colWidth={2}
                      >
                        Response
                      </ActionLayoutHeading>
                      {!hideCorrectAnswerColumn && (
                        <ActionLayoutHeading
                          plainTable
                          className={"justify-content-center "}
                          colWidth={2}
                        >
                          Correct Answer
                        </ActionLayoutHeading>
                      )}
                      {!hideCorrectAnswerColumn && showSourceCol && (
                        <ActionLayoutHeading
                          plainTable
                          className={"justify-content-center "}
                          colWidth={2}
                        >
                          Source
                        </ActionLayoutHeading>
                      )}

                      {
                        data.triviaCategoryType === "SURVEY" &&   <ActionLayoutHeading
                        plainTable
                        className={"justify-content-center "}
                        colWidth={1}
                      >
                        Needs Attention
                      </ActionLayoutHeading>
                      }

                    

                      {!isSurveyCategory && (
                        <ActionLayoutHeading
                          plainTable
                          className={"justify-content-center "}
                          colWidth={1}
                        ></ActionLayoutHeading>
                      )}

                      {quizResponses.map((resp, idx) => {
                        const isCorrect =
                          resp.question.correct_options &&
                          resp.question.correct_options[0] &&
                          resp.selectedAnswer &&
                          resp.question.correct_options[0].option_id ==
                            resp.selectedAnswer.option_id;

                        const answerExists =
                          resp.question &&
                          resp.question.correct_options &&
                          resp.question.correct_options[0];

                    const needsAttention = data && data.quizResponses && data.quizResponses[idx] ? data.quizResponses[idx].needsAttention : false;


                        return (
                          <LayoutRow
                            className={`pl-tasks-row row-scroll-width`}
                            plainTable={true}
                            noHeight
                            style={{
                              width: `${mobileTableWidth}px`,
                              height: "150px",
                              overflowY: "auto",
                            }}
                            key={idx}
                          >
                            <ActionLayoutData
                              colWidth={2}
                              className={` pl-2 ${resp.question &&
                                answerExists &&
                                resp.question.question_type == "MCQ" &&
                                !isTrivvyGeneratedFromCustomTemplates(
                                  triviaObject
                                ) &&
                                `${
                                  isCorrect ? "ans-correct-bg" : "ans-wrong-bg"
                                }`}`}
                              customStyle={
                                resp.question.question_type === "TEXT" &&
                                resp.textSentimentsData
                                  ? {
                                      backgroundColor:
                                        SENTIMENTS_COLOR_MAP[
                                          resp.textSentimentsData.sentiment
                                        ],
                                    }
                                  : {}
                              }
                            >
                              <div sm={3} className={`px-3`}>
                                <div>
                                  {resp.selectedAnswer
                                    ? parse(
                                        typeof resp.selectedAnswer.text ==
                                          "string"
                                          ? resp.selectedAnswer.text
                                          : JSON.stringify(
                                              resp.selectedAnswer.text
                                            )
                                      )
                                    : "No Answer"}
                                </div>
                                {resp.question.question_type === "TEXT" &&
                                  resp.textSentimentsData &&
                                  resp.textSentimentsData.sentiment && (
                                    <div className="mt-sentiment-caption">
                                      <b>
                                        (
                                        {
                                          SENTIMENTS_TYPO_MAP[
                                            resp.textSentimentsData.sentiment
                                          ]
                                        }{" "}
                                        sentiment)
                                      </b>
                                    </div>
                                  )}
                              </div>
                            </ActionLayoutData>
                            {!hideCorrectAnswerColumn && (
                              <ActionLayoutData colWidth={2}>
                                {(resp.question.correct_options &&
                                  resp.question.correct_options[0] &&
                                  parse(
                                    resp.question.correct_options[0].text
                                  )) ||
                                  "NA"}
                              </ActionLayoutData>
                            )}
                            {!hideCorrectAnswerColumn && showSourceCol && (
                              <ActionLayoutData colWidth={2}>
                                {resp.source ? (
                                  resp.source
                                ) : (
                                  <span className="mtTriviaResultDetailsContainer-tbl-cell-source">
                                    No source provided
                                  </span>
                                )}
                              </ActionLayoutData>
                            )}

                            {isSurveyCategory && (
                              <ActionLayoutData colWidth={1}>
                                {needsAttention && (
                                  <FaExclamationTriangle color="goldenrod" size="1.8em" />
                                )}
                              </ActionLayoutData>
                            )}

                            {!isSurveyCategory && (
                              <ActionLayoutData colWidth={1}>
                                {resp.question &&
                                  answerExists &&
                                  resp.question.question_type == "MCQ" &&
                                  !isTrivvyGeneratedFromCustomTemplates(
                                    triviaObject
                                  ) && (
                                    <div className="d-flex justify-content-center align-items-center">
                                      {isCorrect ? (
                                        <BsFillCheckCircleFill
                                          color={"green"}
                                          size={25}
                                        />
                                      ) : (
                                        <BsFillXCircleFill
                                          color={"red"}
                                          size={25}
                                        />
                                      )}{" "}
                                    </div>
                                  )}
                              </ActionLayoutData>
                            )}
                          </LayoutRow>
                        );
                      })}
                    </Row>
                  </Col>
                </LayoutRow>
              </div>
            ) : (
              <div className="mt-4 scrollable-table">
                <Table responsive>
                  <thead
                    className={
                      "font-weight-bold mb-3 ml-0 mr-0 pb-2 border-bottom"
                    }
                  >
                    <tr>
                      <th>Question</th>
                      <th>Response</th>
                      {!hideCorrectAnswerColumn && <th>Correct Answer</th>}

                      {!hideCorrectAnswerColumn && showSourceCol && (
                        <th>Source</th>
                      )}

                      {
                         data.triviaCategoryType === "SURVEY" &&    <th className="text-nowrap">Needs Attention</th>
                      }

                    
                      <th></th>
                    </tr>
                  </thead>

                  <tbody>
                    {quizResponses.map((resp, index) => {
                      if (resp && resp.question) {
                        const isCorrect =
                          resp.question.correct_options &&
                          resp.question.correct_options[0] &&
                          resp.selectedAnswer &&
                          resp.question.correct_options[0].option_id ==
                            resp.selectedAnswer.option_id;

                        const answerExists =
                          resp.question &&
                          resp.question.correct_options &&
                          resp.question.correct_options[0] &&
                          resp.question.correct_options[0].option_id;

                        const needsAttention = data && data.quizResponses && data.quizResponses[index] ? data.quizResponses[index].needsAttention : false;

                        return (
                          <tr key={resp.id}>
                            <td sm={5} className="px-3">
                              {parse(
                                resp.question && resp.question.question_text
                              )}
                            </td>
                            <td
                              sm={3}
                              className={`px-3  ${resp.question &&
                                resp.question.question_type == "MCQ" &&
                                answerExists &&
                                !isTrivvyGeneratedFromCustomTemplates(
                                  triviaObject
                                ) &&
                                `${
                                  isCorrect ? "ans-correct-bg" : "ans-wrong-bg"
                                }`}`}
                              style={
                                resp.question.question_type === "TEXT" &&
                                resp.textSentimentsData
                                  ? {
                                      backgroundColor:
                                        SENTIMENTS_COLOR_MAP[
                                          resp.textSentimentsData.sentiment
                                        ],
                                    }
                                  : {}
                              }
                            >
                              <div>
                                {resp.selectedAnswer
                                  ? parse(
                                      typeof resp.selectedAnswer.text == "string"
                                        ? resp.selectedAnswer.text
                                        : JSON.stringify(resp.selectedAnswer.text)
                                    )
                                  : "No Answer"}
                              </div>
                              {resp.question.question_type === "TEXT" &&
                                resp.textSentimentsData &&
                                resp.textSentimentsData.sentiment && (
                                  <div className="mt-sentiment-caption">
                                    <b>
                                      (
                                      {
                                        SENTIMENTS_TYPO_MAP[
                                          resp.textSentimentsData.sentiment
                                        ]
                                      }{" "}
                                      sentiment)
                                    </b>
                                  </div>
                                )}
                            </td>

                            {!hideCorrectAnswerColumn && (
                              <td sm={3} className="px-3">
                                {(resp.question.correct_options &&
                                  resp.question.correct_options[0] &&
                                  parse(
                                    resp.question.correct_options[0].text
                                  )) ||
                                  "NA"}
                              </td>
                            )}
                            {!hideCorrectAnswerColumn && showSourceCol && (
                              <td sm={3} className="px-3">
                                {resp.source ? (
                                  resp.source
                                ) : (
                                  <span className="mtTriviaResultDetailsContainer-tbl-cell-source">
                                    No source provided
                                  </span>
                                )}
                              </td>
                            )}

                            <td sm={1} className="px-3 text-center">
                            {
                               data.triviaCategoryType === "SURVEY" && needsAttention &&  <FaExclamationTriangle color="goldenrod" size="1.8em" />
                            } 
                            </td>
                            <td sm={1} className="px-3">
                              {resp.question.question_type == "MCQ" &&
                                answerExists &&
                                !isTrivvyGeneratedFromCustomTemplates(
                                  triviaObject
                                ) && (
                                  <div>
                                    {isCorrect ? (
                                      <BsFillCheckCircleFill
                                        color={"green"}
                                        size={25}
                                      />
                                    ) : (
                                      <BsFillXCircleFill
                                        color={"red"}
                                        size={25}
                                      />
                                    )}{" "}
                                  </div>
                                )}
                            </td>
                          </tr>
                        );
                      } else {
                        return "";
                      }
                    })}
                  </tbody>
                </Table>
              </div>
            )}
          </div>
        ) : (
          ""
        )}

        {!hideReminder &&
          data &&
          triviaObject &&
          remindMeDdData &&
          remindMeDdData.length > 0 && (
            <ReminderComponent
              fullWidth
              trivia={triviaObject}
              resultId={data.resultId}
              remindMeDdData={remindMeDdData}
              planType={planType}
            />
          )}
      </ModalBody>
    </Modal>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(MyTriviaDetails);
